import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { PersonstammpersonService, ZentralePersonDetailEntryMeta } from 'app/core/personstamm-api';
import { catchError } from 'rxjs/operators';
import { CapAlertService } from '../../../core/extension/exceptions/cap-alert.service';
import { CapAlertLevel } from '../../../core/extension/exceptions/cap-alert-level.enum';

@Injectable()
export class ZpvDetailResolver {
  readonly ZPV_ID = 'id';

  constructor(
    private translate: TranslateService,
    private capAlertService: CapAlertService,
    private personService: PersonstammpersonService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ZentralePersonDetailEntryMeta> {
    return this.personService.getZentralePerson(route.params[this.ZPV_ID]).pipe(catchError((err) => this.handleError(err)));
  }

  handleError(err): Observable<any> {
    if (err.status === 502) {
      this.capAlertService.warning(this.translate.instant('zpvService.nichtVerfuegbar'), CapAlertLevel.CONTENT_HEADER);
      return EMPTY;
    }
    return EMPTY;
  }
}
